if (!$('#uber').hasClass('moduleInterior')) {
    if (iCreateObject.isSiteInICreateMode) {
        var toggleHtmlStructure = '<div class="toggleContent cf">';

        //if ($("#contactMainContainer").length > 0) {
        //    toggleHtmlStructure += "<label for=\"chkHideRightContact\" class=\"ic-checkbox-inline\">";
        //    toggleHtmlStructure += "<input id=\"chkHideRightContact\" type=\"checkbox\" name=\"chkHideRightContact\" />Hide Contact</label>";
        //}

        toggleHtmlStructure += '<label for="chkHideEmergencyAlert" class="ic-checkbox-inline">';
        toggleHtmlStructure += '<input id="chkHideEmergencyAlert" type="checkbox" name="chkHideEmergencyAlert" />Hide Emergency Alert</label>';

        toggleHtmlStructure += '</div>';

        $('#uberMain').before(toggleHtmlStructure);
    }

    if ($('#TKInteriorHideAreasToggle #frmToggleContent').length <= 0) {
        var myForm = $('<form>');
        myForm.attr({ 'id': 'frmToggleContent', 'action': '#' });

        //if ($("#contactMainContainer").length > 0) {
        //    myForm.append($("<input>").attr({ "type": "hidden", "id": "hdnHideRightContact", "value": $("#contactMainContainer").hasClass("hide") ? "hide" : "" }))
        //}

        myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        myForm.append($('<input>').attr({ 'type': 'submit', 'id': 'btnToggleContent', 'name': 'btnToggleContent', 'aria-label': 'Toggle Content' }).addClass('hideButton'));

        $('#TKInteriorHideAreasToggle').empty().append(myForm);
    } else {
        //Insert emergency alert banner if not already there
        if ($('#TKInteriorHideAreasToggle #frmToggleContent #hdnHideEmergencyAlert').length <= 0) {
            $('#TKInteriorHideAreasToggle #frmToggleContent').prepend($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        }
    }

    // bind checkbox with hidden fields
    if (($('#hdnHideEmergencyAlert').length > 0) && ($('#hdnHideEmergencyAlert').val() === 'hide')) {
        if ($('#chkHideEmergencyAlert').length > 0) {
            $('#chkHideEmergencyAlert').attr('checked', 'checked');
        }
    }
    ////Contact
    //if (($("#hdnHideRightContact").length > 0) && ($("#hdnHideRightContact").val() == "hide")) {
    //    if ($("#chkHideRightContact").length > 0) {
    //        $("#chkHideRightContact").attr("checked", "checked");
    //    }
    //    $("#contactMainContainer").toggleClass("hide", true);
    //} else if (($("#hdnHideRightContact").length > 0) && ($("#hdnHideRightContact").val() == "")) {
    //    $("#contactMainContainer").toggleClass("hide", false);
    //}

    // bind checkbox change event
    if ($('#chkHideEmergencyAlert').length > 0) {
        $('#chkHideEmergencyAlert').change(function () {
            $('#hdnHideEmergencyAlert').val($('#chkHideEmergencyAlert:checked').length > 0 ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }
    ////Contact
    //if ($("#chkHideRightContact").length > 0) {
    //    $("#chkHideRightContact").change(function () {
    //        $("#contactMainContainer").toggleClass("hide", $(this).is(":checked"));
    //        $("#hdnHideRightContact").val($("#contactMainContainer").hasClass("hide") ? "hide" : "");
    //        if (iCreateObject.isSiteInICreateMode) $("#TKInteriorHideAreasToggle").save();
    //    });
    //}
}
